"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.I18n = void 0;
var I18n = /** @class */ (function () {
    function I18n() {
    }
    I18n.init = function (lang) {
        I18n.labels = I18n.i18nLabelsResources[lang];
    };
    I18n.i18nLabelsResources = {
        en: require("./lang/en.json"),
        fr: require("./lang/fr.json"),
    };
    return I18n;
}());
exports.I18n = I18n;
